import radioAuto from '../radio/radio-auto.vue'
radioAuto.install = function (vue) {
  vue.component(radioAuto.name, radioAuto)
}
export default radioAuto



// WEBPACK FOOTER //
// ./src/ui/components/radio-auto/index.js